import { render, staticRenderFns } from "./totalCard.vue?vue&type=template&id=3f322d43&scoped=true&"
import script from "./totalCard.vue?vue&type=script&lang=js&"
export * from "./totalCard.vue?vue&type=script&lang=js&"
import style0 from "./totalCard.vue?vue&type=style&index=0&id=3f322d43&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f322d43",
  null
  
)

export default component.exports